import type { DbPortalFortschritt } from '@gql/shared-types';

export function FortschrittBalken({ f, beschriftung }: { f: DbPortalFortschritt; beschriftung?: string }) {
  const anteil = f.pflicht ? Math.round((f.erledigt / f.pflicht) * 100) : 0;
  const text = beschriftung ?? (f.vollstaendig ? 'vollständig' : `${f.erledigt} von ${f.pflicht} erledigt`);
  return (
    <span className="fortschritt">
      <span className="fortschritt-spur" role="progressbar" aria-valuemin={0} aria-valuemax={f.pflicht} aria-valuenow={f.erledigt} aria-label={text}>
        <span className={`fortschritt-wert${f.vollstaendig ? ' ist-voll' : ''}`} style={{ width: `${anteil}%` }} />
      </span>
      <span className="fortschritt-text">{text}</span>
    </span>
  );
}

export function PrioMarke({ p }: { p: number | null }) {
  if (!p) return <span className="prio prio-0">–</span>;
  return (
    <span className={`prio prio-${p}`} title={`Priorität ${p}`}>
      P{p}
    </span>
  );
}
